<template>
  <div class='index'>
    <div class="aw-container-wrap">
      <div class="container">
        <div class="row">
          <div class="aw-content-wrap clearfix">
            <div class="aw-caiji-setting">
              <div class="col-sm-12 aw-main-content">
                <div class="mod-head common-head">
                  <h2 id="main_title"><i></i>{{$t('sidebar.title')}} <span class="visible-xs-block pull-right"
                      onclick="$(&quot;#dropdown-list-m&quot;).slideToggle();">
                      <font size="5"><i class="fa fa-th-large"></i></font>
                      <div class="aw-mod side-nav dropdown-list" id="dropdown-list-m">
                        <div class="mod-body">
                          <ul>
                            <li v-for="(item, index) in abilityArr" :key="index" @click="clickLi(item, index)"><a
                                :class="{ active: abilityIndex == index }" v-html="item.title"></a></li>
                            <hr>
                            <hr>
                            <li v-for="(item, index) in articleArr" :key="index + 'article'"
                              @click="clickArticle(item, index)">
                              <a v-html="item.title"></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </span>
                  </h2>

                </div>
                <!-- 侧边栏 -->
                <div class="col-sm-3 col-md-3 aw-side-bar hidden-xs clearfix">
                  <div class="aw-mod side-nav" id="side-nav">
                    <div class="mod-body">
                      <ul id="caiji_nav">
                        <li v-for="(item, index) in abilityArr" :key="index" @click="clickLi(item, index)"><a
                            :class="{ active: abilityIndex == index }" v-html="item.title"></a></li>
                        <hr>
                        <hr>
                        <li v-for="(item, index) in articleData" :key="index + 'article'"
                          @click="clickArticle(item, index)">
                          <a v-html="item.title"></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- end 侧边栏 -->
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-title></bottom-title>
  </div>
</template>

<script>
  import {articleList} from "@/api/sys_article.js"
  import { $t } from "@/lang/index.js"
export default {
  data() {
    return {
      articleData: [],
      pageNum: 1, // 当前页
      total: 1, // 总条数
      pageSize:10,
      abilityArr: [{
        // title: `<i></i>${$t('sidebar.adminConsole')} <font color="red">${$t('sidebar.recharge')}</font>`,
        title: `<i></i>${$t('sidebar.adminConsole')}`,
        path: '/adminConsole',
      }, {
        title: `<i></i>${$t('sidebar.webmanage')}`,
        path: '/webmanage',
      },{
        title: `<i></i>${$t('sidebar.push')}`,
        path: '/push',
      }, {
        title: `<i></i>${$t('sidebar.webkeywords')}`,
        path: '/webkeywords',
      }, {
        title: `<i></i>${$t('sidebar.aisetting')}`,
        path: '/aisetting',
      }, {
        title: `<i></i>${$t('sidebar.test')}`,
        path: '/test',
      }, {
        title: `<i></i>${$t('sidebar.data')}`,
        path: '/data',
      }, {
        title: `<i></i>${$t('sidebar.userWallet')}`,
        path: '/userWallet',
      },
      ],
      abilityIndex: 0,
      articleArr: [],
    };
  },
  created() {
    this.setAbilityIndex()
  },
  mounted() {
    this.loadArticle(3);
  },
  methods: {
    loadArticle(location) {
      let param = {
        location: location,
        pageNum: this.pageNum,
        pageSize:this.pageSize
      }
      articleList(param).then(response => {
        if (response.code != 200) {
          this.$message({
            message: response.msg, // 提示内容
            duration: 1500, // 提示持续时间，可省略
            type: 'error' // success成功 warning警告 info消息 error错误
          })
        } else {
          this.articleData = response.rows
          this.total = response.total
        }
      });
    },
    clickLi(item, index) {
      this.$router.push(item.path)
      this.setAbilityIndex()
    },
    setAbilityIndex() {
      let href = location.href;
      if (href.includes('/billingMethod')) this.abilityIndex = null
      if (href.includes('/notice')) this.abilityIndex = null
      if (href.includes('/adminConsole')) this.abilityIndex = 0
      if (href.includes('/addfunds')) this.abilityIndex = 0
      if (href.includes('/webmanage')) this.abilityIndex = 1
      if (href.includes('/addsite')) this.abilityIndex = 1
      if (href.includes('/push')) this.abilityIndex = 2
      if (href.includes('/webkeywords')) this.abilityIndex = 3
      if (href.includes('/massaddtype')) this.abilityIndex = 3
      if (href.includes('/aisetting')) this.abilityIndex = 4
      if (href.includes('/test')) this.abilityIndex = 5
      if (href.includes('/data')) this.abilityIndex = 6
      if (href.includes('/articleedit')) this.abilityIndex = 6
      if (href.includes('/userWallet')) this.abilityIndex = 7
    },
    clickArticle(item) {
      // this.$router.push('/article?id=' + id)
      this.$router.push(`/article/${item.id}.html`)
    },
  },
  computed: {

  },
  watch: {

  },
}
</script>

<style lang="scss" scoped>
@import '../assets/style/caiji.css';
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue